import React, { memo } from "react";
import PropTypes from "prop-types";
import {
  Button,
  Box,
  Stack,
  TextField,
  CircularProgress,
  Typography,
} from "@mui/material";
import { format, differenceInDays } from "date-fns";
import { toast } from "react-toastify";
//import Select from 'react-select';
//import makeAnimated from 'react-select/animated';
import Select from "./select";
import { useSelector } from "react-redux";
import { formatarParaSelect } from "../utils/index";
import _ from "lodash";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
//
import SearchIcon from "@mui/icons-material/Search";
import { seletorUserWithStoreTotal } from "../utils/global-selectors";

const FormPadrao = ({
  onClick,
  ocultarDeAte,
  aguardar,
  diffMax,
  lojasCustom,
  deAteAno,
  anoUnico,
  isMulti,
}) => {
  let schema;

  const yupGrupoLoja = isMulti
    ? yup
        .array()
        .of(
          yup.object().shape({
            label: yup.string().min(1).required(),
            value: yup.string().min(1).required(),
          })
        )
        .min(1)
        .required()
    : yup
        .object()
        .shape({
          label: yup.string().min(1).required(),
          value: yup.string().min(1).required(),
        })
        .required();

  if (ocultarDeAte) {
    schema = yup.object().shape({
      grupo_loja: yupGrupoLoja,
    });
  } else if (deAteAno) {
    schema = yup.object().shape({
      de: yup
        .object()
        .shape({
          label: yup.string().min(1).required(),
          value: yup.string().min(1).required(),
        })
        .required(),
      ate: yup
        .object()
        .shape({
          label: yup.string().min(1).required(),
          value: yup.string().min(1).required(),
        })
        .required(),
      grupo_loja: yupGrupoLoja,
    });
  } else if (anoUnico) {
    // Caso onde se escolhe a loja e o ano unico
    schema = yup.object().shape({
      ano: yup
        .object()
        .shape({
          label: yup.string().min(1).required(),
          value: yup.string().min(1).required(),
        })
        .required(),
      grupo_loja: yupGrupoLoja,
    });
  } else {
    schema = yup.object().shape({
      de: yup.date().required(),
      ate: yup.date().required(),
      grupo_loja: yupGrupoLoja,
    });
  }
  const {
    setError,
    control,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
  });
  const stores = useSelector(seletorUserWithStoreTotal);
  const userDates = useSelector((state) => state.usuario);

  const fn = (val) => {
    const { grupo_loja, de, ate } = val;
    const inGrupoLoja = isMulti ? grupo_loja : [grupo_loja];
    // Verifica se o ano_unico deve ser usado
    if (anoUnico) {
      let lojas;
      const filtro = inGrupoLoja.filter((ele) => ele.label === "TODOS");
      if (filtro.length > 0) {
        lojas = filtro[0].value;
      } else {
        lojas = inGrupoLoja.map((ele) => ele.value).join(",");
      }
      const obj = {
        extraLojas: lojas,
        ano: val.ano.value.toString(),
      };
      // Passando os dados para atualizacao
      onClick(obj);
      return true;
    }

    // Verifica se a data DE e maior que a data ATE
    if (!ocultarDeAte && de > ate) {
      toast.dark("A data DE não deve maior que ATÉ", {
        type: "error",
        toastId: "PADRAO_FORM",
      });
      setError("de", "Data DE maior que ATÉ");
      return false;
    }
    // Se diffMax nao permite atribuir uma diferenca maior que a maxima
    if (diffMax) {
      if (differenceInDays(ate, de) > diffMax) {
        toast.dark(
          `A diferença máxima entre as datas deve ser de (no máximo) ${diffMax} dias.`,
          {
            type: "error",
            toastId: "PADRAO_FORM",
          }
        );
        return false;
      }
    }
    let lojas;

    //
    const filtro = inGrupoLoja.filter((ele) => ele.label === "TODOS");
    if (filtro.length > 0) {
      lojas = filtro[0].value;
    } else {
      lojas = inGrupoLoja.map((ele) => ele.value).join(",");
    }
    const obj = {
      extraLojas: lojas,
    };

    if (deAteAno) {
      obj.de = de.value;
      obj.ate = ate.value;
    } else if (!ocultarDeAte) {
      // Precisa dos campos de/ate eles não podem ser ocultados
      obj.de = format(de, "yyyy-MM-dd");
      obj.ate = format(ate, "yyyy-MM-dd");
    }
    // Passando os dados para atualizacao
    onClick(obj);
  };

  return (
    <Stack
      justifyContent={{ md: "space-evenly" }}
      alignItems={{ md: "center" }}
      direction={{ xs: "column", md: "row" }}
      spacing={1}
    >
      {stores && (
        <Controller
          control={control}
          //defaultValue={formatarParaSelect(valorDefault)}
          name="grupo_loja"
          rules={{ required: true }}
          render={({ field }) => (
            <Box sx={{ display: "flex", flexDirection: "column", flex: 2 }}>
              <Select
                {...field}
                options={formatarParaSelect(lojasCustom || stores)}
                isMulti={isMulti}
                isDisabled={aguardar}
                id={"grupo_loja_id"}
                inputId={"grupo_loja_id_interno"}
              />
              {!!errors.grupo_loja && (
                <Typography variant="caption" color="error">
                  * Escolha ao menos uma loja
                </Typography>
              )}
            </Box>
          )}
        />
      )}
      {anoUnico ? (
        <Controller
          control={control}
          defaultValue={formatarParaSelect([format(new Date(), "yyyy")])[0]}
          name="ano"
          rules={{ required: true }}
          render={({ field }) => (
            <SelectAno
              label="Ano"
              erro={errors.ano}
              erroMensagem="Escolha um ano"
              field={field}
              aguardar={aguardar}
            />
          )}
        />
      ) : deAteAno ? (
        <>
          <Controller
            control={control}
            defaultValue={formatarParaSelect([format(new Date(), "yyyy")])[0]}
            name="de"
            rules={{ required: true }}
            render={({ field }) => (
              <SelectAno
                label="Ano de"
                erro={errors.de}
                erroMensagem="Escolha um ano"
                field={field}
                aguardar={aguardar}
              />
            )}
          />
          <Controller
            control={control}
            defaultValue={formatarParaSelect([format(new Date(), "yyyy")])[0]}
            name="ate"
            rules={{ required: true }}
            render={({ field }) => (
              <SelectAno
                label="Ano até"
                erro={errors.de}
                erroMensagem="Escolha um ano"
                field={field}
                aguardar={aguardar}
              />
            )}
          />
        </>
      ) : (
        userDates?.de &&
        !ocultarDeAte && (
          <>
            <Controller
              control={control}
              defaultValue={userDates?.de}
              name="de"
              rules={{ required: true }}
              render={({ field }) => (
                <TextField
                  {...field}
                  sx={{ flex: 1 }}
                  disabled={aguardar}
                  error={!!errors.de}
                  helperText={!!errors.de && "* Formato inválido"}
                  type="date"
                  size="small"
                  label="Data DE"
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              )}
            />

            <Controller
              control={control}
              defaultValue={userDates?.ate}
              name="ate"
              rules={{ required: true }}
              render={({ field }) => (
                <TextField
                  {...field}
                  error={!!errors.ate}
                  helperText={!!errors.ate && "* Formato inválido"}
                  sx={{ flex: 1 }}
                  type="date"
                  disabled={aguardar}
                  size="small"
                  label="Data ATÉ"
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              )}
            />
          </>
        )
      )}

      <Button
        id="btn_pesquisar"
        onClick={handleSubmit(fn)}
        variant="contained"
        disabled={aguardar}
        startIcon={
          aguardar ? (
            <CircularProgress sx={{ color: "white" }} size={20} />
          ) : (
            <SearchIcon />
          )
        }
      >
        Pesquisar
      </Button>
    </Stack>
  );
};

const anos = _.range(2012, parseInt(format(new Date(), "yyyy")) + 1);
anos.sort((a, b) => (a > b ? -1 : 1));

// Criar campo para Select anos
const SelectAno = ({ label, field, aguardar, erro, erroMensagem }) => {
  const inAnos = formatarParaSelect(anos);

  return (
    <Box sx={{ display: "flex", flexDirection: "column", flex: 2 }}>
      <Select {...field} options={inAnos} isDisabled={aguardar} />
      {!!erro && (
        <Typography variant="caption" color="error">
          {erroMensagem}
        </Typography>
      )}
    </Box>
  );
};

FormPadrao.defaultProps = {
  isMulti: true,
};

FormPadrao.propTypes = {
  onClick: PropTypes.func.isRequired,
  ocultarDeAte: PropTypes.bool,
  aguardar: PropTypes.bool,
  diffMax: PropTypes.number,
  lojasCustom: PropTypes.arrayOf(PropTypes.array),
  deAteAno: PropTypes.bool,
  anoUnico: PropTypes.bool,
  isMulti: PropTypes.bool,
};

export default memo(FormPadrao);
